/**
 * DateTimeFormatUtils
 *
 * Pure utility functions for date/time formatting and comparison.
 * Extracted from use-event-form-state for reuse and file size management.
 */

export function formatDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function formatTime(date: Date): string {
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${hours}:${minutes}`;
}

export function addMinutesToDate(date: Date, minutes: number): Date {
  return new Date(date.getTime() + minutes * 60 * 1000);
}

export function parseDateTime(dateStr: string, timeStr: string | null): Date {
  const [year, month, day] = dateStr.split('-').map(Number);
  const date = new Date(year, month - 1, day);
  if (timeStr) {
    const [hours, minutes] = timeStr.split(':').map(Number);
    date.setHours(hours, minutes, 0, 0);
  }
  return date;
}

export function compareDateTimes(
  date1: string,
  time1: string | null,
  date2: string,
  time2: string | null,
  allDay: boolean
): number {
  if (allDay) {
    return date1.localeCompare(date2);
  }
  const dt1 = parseDateTime(date1, time1);
  const dt2 = parseDateTime(date2, time2);
  return dt1.getTime() - dt2.getTime();
}
